import React, { useCallback, useEffect, useState } from 'react';
import { X } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function AdminMessageInbox() {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const refresh = useCallback(async () => {
    if (!user) return;
    try { const { data } = await api.get('/auth/admin-messages', { skipAuthRefresh: true }); setMessages(data); } catch { /* optional polling never changes auth state */ }
  }, [user]);
  useEffect(() => {
    if (!user) return undefined;
    api.post('/auth/presence', {}, { skipAuthRefresh: true }).catch(() => {}); refresh();
    const presenceTimer = setInterval(() => api.post('/auth/presence', {}, { skipAuthRefresh: true }).catch(() => {}), 45000);
    const messageTimer = setInterval(refresh, 12000);
    const visible = () => { if (!document.hidden) { api.post('/auth/presence', {}, { skipAuthRefresh: true }).catch(() => {}); refresh(); } };
    document.addEventListener('visibilitychange', visible);
    return () => { clearInterval(presenceTimer); clearInterval(messageTimer); document.removeEventListener('visibilitychange', visible); };
  }, [user, refresh]);
  const dismiss = async (id) => { setMessages((items) => items.filter((item) => item.id !== id)); await api.post(`/auth/admin-messages/${id}/dismiss`, {}, { skipAuthRefresh: true }).catch(() => {}); };
  if (!user || !messages.length) return null;
  return <div className="fixed bottom-20 right-4 z-[100] w-[min(360px,calc(100vw-2rem))] space-y-3" aria-live="polite">{messages.slice().reverse().map((message) => <article key={message.id} className="bg-white border border-amber-300 shadow-2xl p-4 rounded-md"><div className="flex justify-between gap-3"><div><strong className="text-amber-600">Admin</strong><p className="mt-1 text-sm text-[var(--brand-text)] whitespace-pre-wrap">{message.text}</p></div><button aria-label="Dismiss admin message" onClick={() => dismiss(message.id)} className="self-start text-[var(--brand-text-sec)]"><X size={17} /></button></div></article>)}</div>;
}
